// src/screens/FormCreatorScreen.css.js

import { StyleSheet } from 'react-native';
import { AVAQualisTheme } from '../theme/theme';

export const styles = StyleSheet.create({
  // Container Principal
  container: {
    flex: 1,
    backgroundColor: AVAQualisTheme.colors.background,
  },
  
  // Placeholder text (com cor cinza)
  placeholderText: {
    color: '#9E9E9E', // Tom de cinza para placeholders
    fontStyle: 'italic',
  },
  
  // Header
  appbar: {
    backgroundColor: AVAQualisTheme.colors.primary,
    elevation: 4,
  },
  appbarTitle: {
    color: AVAQualisTheme.colors.onPrimary,
    fontWeight: 'bold',
    fontSize: 16,
  },
  appbarSubtitle: {
    color: AVAQualisTheme.colors.onPrimary,
    opacity: 0.9,
    fontSize: 12,
  },

  // Abas de Navegação
  tabContainer: {
    flexDirection: 'row',
    backgroundColor: AVAQualisTheme.colors.surface,
    borderBottomWidth: 1,
    borderBottomColor: AVAQualisTheme.colors.outline,
    elevation: 2,
  },
  tab: {
    flex: 1,
    paddingVertical: AVAQualisTheme.spacing.md,
    paddingHorizontal: AVAQualisTheme.spacing.sm,
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'row',
    backgroundColor: 'transparent',
    borderBottomWidth: 3,
    borderBottomColor: 'transparent',
  },
  activeTab: {
    backgroundColor: `${AVAQualisTheme.colors.primary}10`,
    borderBottomColor: AVAQualisTheme.colors.primary,
  },
  tabText: {
    fontSize: 14,
    fontWeight: '600',
    color: AVAQualisTheme.colors.secondary,
    marginRight: AVAQualisTheme.spacing.xs,
  },
  activeTabText: {
    color: AVAQualisTheme.colors.primary,
    fontWeight: 'bold',
  },
  tabBadge: {
    backgroundColor: AVAQualisTheme.colors.error,
    color: AVAQualisTheme.colors.onPrimary,
    fontSize: 10,
  },

  // Conteúdo Principal
  content: {
    flex: 1,
    padding: AVAQualisTheme.spacing.md,
  },

  // Container de metadados com z-index máximo
  metadataContainer: {
    zIndex: 10000, // Z-index MÁXIMO para metadados
    marginBottom: AVAQualisTheme.spacing.md,
  },

  // Container com z-index baixo para outras seções
  lowZIndexContainer: {
    zIndex: 1, // Z-index baixo para não interferir com dropdown
  },

  // Metadados do formulário
  metadataCard: {
    backgroundColor: AVAQualisTheme.colors.surface,
    borderRadius: AVAQualisTheme.borderRadius.lg,
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.1,
    shadowRadius: 4,
    elevation: 2,
    borderLeftWidth: 4,
    borderLeftColor: AVAQualisTheme.colors.tertiary,
    zIndex: 10000, // Z-index MÁXIMO para o card de metadados
  },
  
  // Avaliadores
  evaluatorsSection: {
    marginTop: AVAQualisTheme.spacing.md,
    marginBottom: AVAQualisTheme.spacing.md,
    zIndex: 9999,
  },
  evaluatorsContainer: {
    flexDirection: 'row',
    gap: AVAQualisTheme.spacing.md,
    marginBottom: AVAQualisTheme.spacing.md,
  },
  evaluatorCard: {
    flex: 1,
    backgroundColor: AVAQualisTheme.colors.surface,
    borderRadius: AVAQualisTheme.borderRadius.lg,
    borderWidth: 2,
    borderColor: AVAQualisTheme.colors.outline,
    position: 'relative',
    overflow: 'hidden',
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 1 },
    shadowOpacity: 0.1,
    shadowRadius: 2,
    elevation: 1,
  },
  evaluatorTouchable: {
    padding: AVAQualisTheme.spacing.md,
    minHeight: 90,
  },
  evaluatorHeader: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: AVAQualisTheme.spacing.xs,
  },
  evaluatorLabel: {
    fontSize: 12,
    fontWeight: 'bold',
    color: AVAQualisTheme.colors.primary,
    textTransform: 'uppercase',
    letterSpacing: 0.5,
  },
  evaluatorClickIcon: {
    fontSize: 16,
    opacity: 0.7,
  },
  evaluatorName: {
    fontSize: 14,
    fontWeight: '600',
    color: AVAQualisTheme.colors.onSurface,
    marginBottom: AVAQualisTheme.spacing.xs,
    minHeight: 20,
  },
  evaluatorLogin: {
    fontSize: 11,
    color: AVAQualisTheme.colors.secondary,
    fontStyle: 'italic',
  },
  removeEvaluatorButton: {
    position: 'absolute',
    top: 8,
    right: 8,
    backgroundColor: AVAQualisTheme.colors.errorContainer,
    borderRadius: 12,
    width: 24,
    height: 24,
    justifyContent: 'center',
    alignItems: 'center',
  },
  removeEvaluatorText: {
    fontSize: 12,
    color: AVAQualisTheme.colors.error,
    fontWeight: 'bold',
  },

  // Seleção Rápida Melhorada
  quickSelectionContainer: {
    backgroundColor: '#f8f9fa',
    borderRadius: AVAQualisTheme.borderRadius.lg,
    padding: AVAQualisTheme.spacing.md,
    borderWidth: 1,
    borderColor: '#e9ecef',
  },
  quickSelectionTitle: {
    fontSize: 14,
    fontWeight: '600',
    color: '#495057',
    marginBottom: AVAQualisTheme.spacing.sm,
  },
  quickSelectionButtons: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: 8,
    marginBottom: AVAQualisTheme.spacing.sm,
  },
  quickSelectionButton: {
    backgroundColor: 'white',
    borderRadius: AVAQualisTheme.borderRadius.md,
    paddingHorizontal: AVAQualisTheme.spacing.sm,
    paddingVertical: AVAQualisTheme.spacing.xs,
    borderWidth: 1,
    borderColor: '#dee2e6',
    minWidth: 80,
  },
  quickSelectionButtonSelected: {
    backgroundColor: AVAQualisTheme.colors.success,
    borderColor: AVAQualisTheme.colors.success,
  },
  quickSelectionButtonText: {
    fontSize: 12,
    textAlign: 'center',
    color: '#495057',
    fontWeight: '500',
  },
  quickSelectionButtonTextSelected: {
    color: 'white',
    fontWeight: '600',
  },
  evaluatorsStatus: {
    backgroundColor: 'white',
    borderRadius: AVAQualisTheme.borderRadius.sm,
    padding: AVAQualisTheme.spacing.sm,
    borderWidth: 1,
    borderColor: '#dee2e6',
  },
  evaluatorsStatusText: {
    fontSize: 12,
    color: '#6c757d',
    textAlign: 'center',
  },

  // Estilos para campos clicáveis
  clickableField: {
    backgroundColor: AVAQualisTheme.colors.surface,
    borderRadius: AVAQualisTheme.borderRadius.md,
    borderWidth: 2,
    borderColor: AVAQualisTheme.colors.outline,
    padding: AVAQualisTheme.spacing.md,
    minHeight: 60,
  },
  clickableFieldSelected: {
    borderColor: AVAQualisTheme.colors.primary,
    backgroundColor: `${AVAQualisTheme.colors.primary}10`,
  },
  clickableFieldLabel: {
    fontSize: 12,
    fontWeight: 'bold',
    color: AVAQualisTheme.colors.primary,
    marginBottom: AVAQualisTheme.spacing.xs,
  },
  clickableFieldValue: {
    fontSize: 14,
    color: AVAQualisTheme.colors.onSurface,
    flex: 1,
  },
  clickableFieldIcon: {
    fontSize: 16,
    color: AVAQualisTheme.colors.secondary,
    position: 'absolute',
    top: AVAQualisTheme.spacing.sm,
    right: AVAQualisTheme.spacing.sm,
  },

  // Estilos antigos mantidos para compatibilidade
  evaluatorsRow: {
    flexDirection: 'row',
    gap: AVAQualisTheme.spacing.sm,
  },
  evaluatorField: {
    flex: 1,
    zIndex: 9999, // Alto z-index
  },
  evaluatorChip: {
    backgroundColor: `${AVAQualisTheme.colors.tertiary}15`,
    borderColor: AVAQualisTheme.colors.tertiary,
    marginTop: AVAQualisTheme.spacing.xs,
    alignSelf: 'flex-start',
  },
  
  // Data e Horário
  dateTimeContainer: {
    flexDirection: 'row',
    gap: AVAQualisTheme.spacing.sm,
    marginBottom: AVAQualisTheme.spacing.md,
    zIndex: 9999, // Alto z-index
  },
  dateInputContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: AVAQualisTheme.spacing.sm,
    flex: 1,
  },
  timeInputContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: AVAQualisTheme.spacing.sm,
    flex: 1,
  },
  dateInput: {
    flex: 1,
    backgroundColor: AVAQualisTheme.colors.background,
  },
  timeInput: {
    flex: 1,
    backgroundColor: AVAQualisTheme.colors.background,
  },
  calendarButton: {
    backgroundColor: AVAQualisTheme.colors.primary,
    borderRadius: AVAQualisTheme.borderRadius.md,
    padding: AVAQualisTheme.spacing.sm,
    justifyContent: 'center',
    alignItems: 'center',
    minWidth: 50,
    height: 56,
  },
  clockButton: {
    backgroundColor: AVAQualisTheme.colors.primary,
    borderRadius: AVAQualisTheme.borderRadius.md,
    padding: AVAQualisTheme.spacing.sm,
    justifyContent: 'center',
    alignItems: 'center',
    minWidth: 50,
    height: 56,
  },
  calendarButtonText: {
    color: AVAQualisTheme.colors.onPrimary,
    fontSize: 20,
  },
  clockButtonText: {
    color: AVAQualisTheme.colors.onPrimary,
    fontSize: 20,
  },

  // Contato e Local
  contactLocationContainer: {
    flexDirection: 'row',
    gap: AVAQualisTheme.spacing.sm,
    marginBottom: AVAQualisTheme.spacing.md,
    zIndex: 9999, // Alto z-index
  },
  contactInputContainer: {
    flex: 1,
  },
  locationInputContainer: {
    flex: 1,
  },
  contactInput: {
    backgroundColor: AVAQualisTheme.colors.background,
  },
  locationInput: {
    backgroundColor: AVAQualisTheme.colors.background,
  },
  
  // Dropdown de unidade organizacional com z-index EXTREMO
  unitDropdownContainer: {
    position: 'relative',
    zIndex: 100000, // Z-index EXTREMO para ficar por cima de tudo
    marginBottom: AVAQualisTheme.spacing.xl, // ESPAÇO EXTRA para não sobrepor próxima seção
  },
  unitInput: {
    marginBottom: AVAQualisTheme.spacing.sm,
    backgroundColor: AVAQualisTheme.colors.background,
    zIndex: 100000,
  },
  unitDropdownList: {
    position: 'absolute',
    top: '100%',
    left: 0,
    right: 0,
    backgroundColor: AVAQualisTheme.colors.surface,
    borderRadius: AVAQualisTheme.borderRadius.md,
    borderWidth: 2, // Borda mais grossa para destaque
    borderColor: AVAQualisTheme.colors.primary,
    maxHeight: 300,
    zIndex: 999999, // Z-index MÁXIMO ABSOLUTO
    elevation: 100, // Elevation MÁXIMA para Android
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 12 },
    shadowOpacity: 0.6,
    shadowRadius: 16,
  },
  unitDropdownItem: {
    padding: AVAQualisTheme.spacing.md,
    borderBottomWidth: 1,
    borderBottomColor: AVAQualisTheme.colors.outline + '30',
    backgroundColor: AVAQualisTheme.colors.surface, // GARANTIR fundo sólido
  },
  unitDropdownItemHovered: {
    backgroundColor: `${AVAQualisTheme.colors.primary}10`,
  },
  unitDropdownText: {
    fontSize: 14,
    color: AVAQualisTheme.colors.onSurface,
    fontWeight: '600',
  },
  unitDropdownSubtext: {
    fontSize: 12,
    color: AVAQualisTheme.colors.secondary,
    marginTop: 2,
  },
  unitDropdownHierarchy: {
    fontSize: 11,
    color: AVAQualisTheme.colors.tertiary,
    marginTop: 4,
    fontStyle: 'italic',
  },

  // NOVOS ESTILOS - Múltiplas Unidades Organizacionais
  unidadesCounter: {
    backgroundColor: `${AVAQualisTheme.colors.info}15`,
    padding: AVAQualisTheme.spacing.sm,
    borderRadius: AVAQualisTheme.borderRadius.md,
    marginBottom: AVAQualisTheme.spacing.sm,
  },
  unidadesCounterText: {
    fontSize: 13,
    color: AVAQualisTheme.colors.info,
    fontWeight: '600',
    textAlign: 'center',
  },
  selectedUnidadesList: {
    backgroundColor: '#f8f9fa',
    borderRadius: AVAQualisTheme.borderRadius.md,
    borderWidth: 1,
    borderColor: '#e9ecef',
    padding: AVAQualisTheme.spacing.sm,
    marginBottom: AVAQualisTheme.spacing.sm,
  },
  selectedUnidadesScroll: {
    maxHeight: 250,
  },
  selectedUnidadeCard: {
    backgroundColor: AVAQualisTheme.colors.surface,
    borderRadius: AVAQualisTheme.borderRadius.md,
    borderWidth: 1,
    borderColor: AVAQualisTheme.colors.info,
    borderLeftWidth: 3,
    marginBottom: AVAQualisTheme.spacing.sm,
    padding: AVAQualisTheme.spacing.sm,
    position: 'relative',
  },
  selectedUnidadeHeader: {
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: AVAQualisTheme.spacing.xs,
  },
  selectedUnidadeIndex: {
    fontSize: 14,
    fontWeight: 'bold',
    color: AVAQualisTheme.colors.info,
    marginRight: 8,
    width: 20,
  },
  selectedUnidadeCode: {
    fontSize: 14,
    fontWeight: '600',
    color: AVAQualisTheme.colors.info,
  },
  removeUnidadeButton: {
    position: 'absolute',
    top: 0,
    right: 0,
    backgroundColor: AVAQualisTheme.colors.errorContainer,
    borderRadius: 12,
    width: 24,
    height: 24,
    justifyContent: 'center',
    alignItems: 'center',
  },
  removeUnidadeText: {
    fontSize: 12,
    color: AVAQualisTheme.colors.error,
    fontWeight: 'bold',
  },
  selectedUnidadeName: {
    fontSize: 13,
    fontWeight: '500',
    color: AVAQualisTheme.colors.onSurface,
    marginBottom: AVAQualisTheme.spacing.xs,
  },
  selectedUnidadeDetails: {
    fontSize: 11,
    color: AVAQualisTheme.colors.secondary,
    marginBottom: 2,
  },
 selectedUnidadeHierarchy: {
    fontSize: 10,
    color: AVAQualisTheme.colors.tertiary,
    fontStyle: 'italic',
  },

  // NOVOS ESTILOS - Para exibição de unidades organizacionais no formato do FormListScreen
  unidadesExpandable: {
    marginTop: AVAQualisTheme.spacing.sm,
  },
  unidadesLabel: {
    fontSize: 13,
    fontWeight: 'bold',
    color: AVAQualisTheme.colors.info,
    marginBottom: AVAQualisTheme.spacing.xs,
  },
  unidadesInlineContainer: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: AVAQualisTheme.spacing.md,
    marginVertical: AVAQualisTheme.spacing.xs,
  },
  unidadeCardInline: {
    backgroundColor: `${AVAQualisTheme.colors.info}08`,
    borderRadius: AVAQualisTheme.borderRadius.sm,
    borderLeftWidth: 2,
    borderLeftColor: AVAQualisTheme.colors.info,
    padding: AVAQualisTheme.spacing.sm,
    marginBottom: AVAQualisTheme.spacing.xs,
    flexBasis: 'calc(50% - 12px)',
    flexShrink: 1,
    flexGrow: 0,
    minWidth: 280,
    maxWidth: '100%',
  },
  unidadeCardInlineHeader: {
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 2,
  },
  unidadeCardInlineIndex: {
    fontSize: 12,
    fontWeight: 'bold',
    color: AVAQualisTheme.colors.info,
    marginRight: 4,
  },
  unidadeCardInlineCode: {
    fontSize: 12,
    fontWeight: 'bold',
    color: AVAQualisTheme.colors.info,
  },
  unidadeCardInlineName: {
    fontSize: 12,
    fontWeight: '500',
    color: AVAQualisTheme.colors.onSurface,
    marginBottom: 2,
  },
  unidadeCardInlineContact: {
    fontSize: 11,
    color: AVAQualisTheme.colors.secondary,
    marginBottom: 1,
  },
  unidadeCardInlineHierarchy: {
    fontSize: 10,
    fontStyle: 'italic',
    color: AVAQualisTheme.colors.tertiary,
  },

  // NOVOS ESTILOS - Metadados inline com layout responsivo
  metadataInlineContainer: {
    backgroundColor: `${AVAQualisTheme.colors.primary}05`,
    padding: AVAQualisTheme.spacing.sm,
    borderRadius: AVAQualisTheme.borderRadius.md,
    borderLeftWidth: 3,
    borderLeftColor: AVAQualisTheme.colors.primary,
    marginVertical: AVAQualisTheme.spacing.sm,
  },
  metadataInlineRow: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    alignItems: 'center',
    marginBottom: AVAQualisTheme.spacing.xs,
  },
  metadataInlineText: {
    fontSize: 12,
    color: AVAQualisTheme.colors.tertiary,
    fontWeight: '600',
    marginRight: AVAQualisTheme.spacing.md,
    marginBottom: AVAQualisTheme.spacing.xs,
    flexShrink: 1,
  },

  // Estilos antigos para compatibilidade
  selectedUnitInfo: {
    marginTop: AVAQualisTheme.spacing.sm,
    zIndex: 100000,
  },
  selectedUnitChip: {
    backgroundColor: `${AVAQualisTheme.colors.success}15`,
    borderColor: AVAQualisTheme.colors.success,
    marginBottom: AVAQualisTheme.spacing.xs,
    alignSelf: 'flex-start',
  },
  unitDetails: {
    fontSize: 12,
    color: AVAQualisTheme.colors.secondary,
    marginBottom: 2,
  },
  unitHierarchy: {
    fontSize: 11,
    color: AVAQualisTheme.colors.tertiary,
    fontStyle: 'italic',
  },

  // Modal label
  modalLabel: {
    fontSize: 14,
    fontWeight: 'bold',
    color: AVAQualisTheme.colors.secondary,
    marginBottom: AVAQualisTheme.spacing.xs,
  },

  // Cards de Seção - REDUZIDA ELEVATION para não competir com dropdown
  sectionCard: {
    marginBottom: AVAQualisTheme.spacing.md,
    backgroundColor: AVAQualisTheme.colors.surface,
    borderRadius: AVAQualisTheme.borderRadius.lg,
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.1,
    shadowRadius: 4,
    elevation: 1, // REDUZIDO para 1 (era 2)
    borderLeftWidth: 4,
    borderLeftColor: AVAQualisTheme.colors.primary,
    zIndex: 1, // Z-index baixo
  },
  
  selectedCard: {
    marginBottom: AVAQualisTheme.spacing.md,
    backgroundColor: AVAQualisTheme.colors.surface,
    borderRadius: AVAQualisTheme.borderRadius.lg,
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.1,
    shadowRadius: 4,
    elevation: 1, // REDUZIDO para 1 (era 2)
    borderLeftWidth: 4,
    borderLeftColor: AVAQualisTheme.colors.success,
    zIndex: 1, // Z-index baixo
  },
  
  requirementsCard: {
    marginBottom: AVAQualisTheme.spacing.md,
    backgroundColor: AVAQualisTheme.colors.surface,
    borderRadius: AVAQualisTheme.borderRadius.lg,
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.1,
    shadowRadius: 4,
    elevation: 1, // REDUZIDO para 1 (era 2)
    borderLeftWidth: 4,
    borderLeftColor: AVAQualisTheme.colors.info,
    zIndex: 1, // Z-index baixo
  },

  sectionTitle: {
    fontSize: 18,
    color: AVAQualisTheme.colors.primary,
    fontWeight: 'bold',
    marginBottom: AVAQualisTheme.spacing.md,
  },

  // Inputs
  input: {
    marginBottom: AVAQualisTheme.spacing.md,
    backgroundColor: AVAQualisTheme.colors.background,
  },
  
  searchInput: {
    marginBottom: AVAQualisTheme.spacing.sm,
    backgroundColor: AVAQualisTheme.colors.background,
  },

  // Resumo do Formulário
  formSummary: {
    backgroundColor: `${AVAQualisTheme.colors.success}15`,
    padding: AVAQualisTheme.spacing.md,
    borderRadius: AVAQualisTheme.borderRadius.md,
    borderLeftWidth: 3,
    borderLeftColor: AVAQualisTheme.colors.success,
    marginTop: AVAQualisTheme.spacing.sm,
  },
  summaryText: {
    fontSize: 14,
    color: AVAQualisTheme.colors.success,
    fontWeight: '600',
    marginBottom: AVAQualisTheme.spacing.xs,
  },

  // Resultados da Pesquisa
  searchResults: {
    fontSize: 12,
    color: AVAQualisTheme.colors.secondary,
    fontWeight: '500',
    marginTop: AVAQualisTheme.spacing.xs,
    fontStyle: 'italic',
  },

  // Nota sobre expansão automática
  autoExpandNote: {
    color: AVAQualisTheme.colors.tertiary,
    fontStyle: 'italic',
    fontSize: 11,
  },
  
  // NOVOS ESTILOS - Indicador de pesquisa e resultados
  searchingContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    marginTop: AVAQualisTheme.spacing.xs,
  },
  searchingIndicator: {
    marginLeft: 8,
    flexDirection: 'row',
    alignItems: 'center',
  },
  searchingIcon: {
    fontSize: 14,
    marginRight: 4,
  },
  searchingText: {
    fontSize: 12,
    color: '#666',
    fontStyle: 'italic',
  },
  searchResultMessage: {
    fontSize: 12, 
    color: '#2196F3', 
    fontStyle: 'italic',
    marginLeft: 8,
    flex: 1,
  },

  // Requisitos Selecionados
  selectedHeader: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: AVAQualisTheme.spacing.sm,
  },
  selectedBadge: {
    backgroundColor: AVAQualisTheme.colors.success,
    color: AVAQualisTheme.colors.onPrimary,
  },
  orderInfo: {
    fontSize: 13,
    color: AVAQualisTheme.colors.secondary,
    fontWeight: '500',
    marginBottom: AVAQualisTheme.spacing.md,
    fontStyle: 'italic',
  },
  
  selectedScroll: {
    maxHeight: 300,
    marginBottom: AVAQualisTheme.spacing.md,
  },
  
  selectedItem: {
    backgroundColor: `${AVAQualisTheme.colors.success}10`,
    padding: AVAQualisTheme.spacing.md,
    marginBottom: AVAQualisTheme.spacing.sm,
    borderRadius: AVAQualisTheme.borderRadius.md,
    borderLeftWidth: 3,
    borderLeftColor: AVAQualisTheme.colors.success,
  },
  
  selectedItemHeader: {
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: AVAQualisTheme.spacing.xs,
  },
  
  selectedOrder: {
    fontSize: 16,
    fontWeight: 'bold',
    color: AVAQualisTheme.colors.success,
    marginRight: AVAQualisTheme.spacing.sm,
    minWidth: 25,
  },
  
  selectedChip: {
    backgroundColor: `${AVAQualisTheme.colors.info}20`,
    borderColor: AVAQualisTheme.colors.info,
    marginRight: AVAQualisTheme.spacing.xs,
  },
  
  essentialChip: {
    backgroundColor: '#FFF3CD',
    borderColor: '#FFC107',
    marginRight: AVAQualisTheme.spacing.xs,
  },
  
  removeButton: {
    marginLeft: 'auto',
    margin: 0,
  },
  
  selectedQuestion: {
    fontSize: 14,
    color: AVAQualisTheme.colors.onSurface,
    lineHeight: 20,
    marginBottom: AVAQualisTheme.spacing.sm,
  },
  
  reorderButtons: {
    flexDirection: 'row',
    gap: AVAQualisTheme.spacing.xs,
  },
  
  reorderButton: {
    borderColor: AVAQualisTheme.colors.primary,
    minWidth: 60,
  },

  // Botões de Ação
  saveButton: {
    borderRadius: AVAQualisTheme.borderRadius.md,
    marginTop: AVAQualisTheme.spacing.sm,
  },

  // Seções de Requisitos
  requirementSection: {
    marginBottom: AVAQualisTheme.spacing.lg,
  },
  
  sectionHeaderButton: {
    backgroundColor: AVAQualisTheme.colors.surfaceVariant,
    padding: AVAQualisTheme.spacing.md,
    borderRadius: AVAQualisTheme.borderRadius.md,
    marginBottom: AVAQualisTheme.spacing.sm,
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 1 },
    shadowOpacity: 0.1,
    shadowRadius: 2,
    elevation: 1,
  },
  
  sectionHeaderContent: {
    flex: 1,
  },
  
  sectionHeaderTitle: {
    fontSize: 16,
    fontWeight: 'bold',
    color: AVAQualisTheme.colors.primary,
    marginBottom: AVAQualisTheme.spacing.xs,
  },
  
  sectionHeaderSubtitle: {
    fontSize: 13,
    color: AVAQualisTheme.colors.secondary,
    fontWeight: '500',
  },
  
  sectionToggle: {
    fontSize: 16,
    color: AVAQualisTheme.colors.primary,
    fontWeight: 'bold',
  },
  
  requirementsList: {
    paddingLeft: AVAQualisTheme.spacing.sm,
  },

  // ESTILOS MODIFICADOS - Itens de Requisito com espaçamento reduzido
  requirementItem: {
    backgroundColor: AVAQualisTheme.colors.background,
    padding: AVAQualisTheme.spacing.sm, // REDUZIDO de md para sm
    marginBottom: AVAQualisTheme.spacing.xs, // REDUZIDO de sm para xs
    borderRadius: AVAQualisTheme.borderRadius.md,
    borderWidth: 2,
    borderColor: AVAQualisTheme.colors.outline,
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 1 },
    shadowOpacity: 0.1,
    shadowRadius: 2,
    elevation: 1,
  },
  
  requirementItemSelected: {
    backgroundColor: `${AVAQualisTheme.colors.success}10`,
    borderColor: AVAQualisTheme.colors.success,
    borderWidth: 2,
  },
  
  requirementHeader: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: AVAQualisTheme.spacing.xs, // REDUZIDO de sm para xs
  },
  
  requirementMeta: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: AVAQualisTheme.spacing.xs,
  },
  
  requirementChip: {
    backgroundColor: `${AVAQualisTheme.colors.info}15`,
    borderColor: AVAQualisTheme.colors.info,
  },
  
  requirementChipSelected: {
    backgroundColor: `${AVAQualisTheme.colors.success}20`,
    borderColor: AVAQualisTheme.colors.success,
  },
  
  selectionIndicator: {
    fontSize: 20,
    color: AVAQualisTheme.colors.outline,
  },
  
  selectionIndicatorSelected: {
    color: AVAQualisTheme.colors.success,
  },
  
  // NOVOS ESTILOS - Estrutura para campos do requisito
  requirementContent: {
    marginBottom: AVAQualisTheme.spacing.xs, // Espaçamento pequeno entre campos
  },
  
  requirementLabel: {
    fontWeight: 'bold',
    color: AVAQualisTheme.colors.primary,
    fontSize: 13,
    marginBottom: 2,
  },
  
  requirementText: {
    fontSize: 14,
    color: AVAQualisTheme.colors.onSurface,
    fontWeight: '400',
    lineHeight: 20,
  },
  
  requirementPremissaText: {
    fontSize: 13,
    color: AVAQualisTheme.colors.secondary,
    lineHeight: 18,
    fontStyle: 'italic',
  },
  
  requirementFontesText: {
    fontSize: 13,
    color: AVAQualisTheme.colors.secondary,
    lineHeight: 18,
  },
  
  requirementSegmentoText: {
    fontSize: 12, // FONTE MENOR para segmento
    color: AVAQualisTheme.colors.tertiary,
    lineHeight: 16,
    fontStyle: 'italic', // ITÁLICO para segmento
  },
  
  selectedOrderInfo: {
    backgroundColor: `${AVAQualisTheme.colors.success}20`,
    padding: AVAQualisTheme.spacing.xs, // REDUZIDO de sm para xs
    borderRadius: AVAQualisTheme.borderRadius.sm,
    marginTop: AVAQualisTheme.spacing.xs, // REDUZIDO de sm para xs
  },
  
  selectedOrderText: {
    fontSize: 12,
    color: AVAQualisTheme.colors.success,
    fontWeight: 'bold',
    textAlign: 'center',
  },

  // Seção de Gerenciamento
  manageSection: {
    flex: 1,
  },
  
  manageDescription: {
    fontSize: 14,
    color: AVAQualisTheme.colors.secondary,
    lineHeight: 20,
    fontStyle: 'italic',
    marginBottom: AVAQualisTheme.spacing.md,
  },

  // Cards de Formulários Salvos - ATUALIZADOS
  formCard: {
    marginBottom: AVAQualisTheme.spacing.md,
    backgroundColor: AVAQualisTheme.colors.surface,
    borderRadius: AVAQualisTheme.borderRadius.lg,
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.1,
    shadowRadius: 4,
    elevation: 2,
    borderLeftWidth: 4,
    borderLeftColor: AVAQualisTheme.colors.warning,
  },
  
  uploadedFormCard: {
    borderLeftColor: AVAQualisTheme.colors.success,
    backgroundColor: `${AVAQualisTheme.colors.surface}`, // Cor um pouco mais clara
  },
  
  // NOVO ESTILO - Card com status alterado
  formCardStatusChanged: {
    borderLeftColor: '#FFC107', // Cor de alerta para status alterado
    backgroundColor: '#FFFDE7', // Fundo levemente amarelado para destacar
  },
  
  formCardHeader: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    marginBottom: AVAQualisTheme.spacing.sm,
  },
  
  formCardInfo: {
    flex: 1,
    marginRight: AVAQualisTheme.spacing.sm,
  },
  
  formCardTitle: {
    fontSize: 16,
    color: AVAQualisTheme.colors.onSurface,
    fontWeight: 'bold',
    marginBottom: AVAQualisTheme.spacing.xs,
    lineHeight: 22,
  },
  
  formCardDate: {
    fontSize: 12,
    color: AVAQualisTheme.colors.secondary,
    marginBottom: 2,
    fontWeight: '500',
  },
  
  formCardUploadDate: {
    fontSize: 12,
    color: AVAQualisTheme.colors.success,
    fontWeight: '500',
  },
  
  formCardStatus: {
    alignItems: 'flex-end',
  },
  
  uploadedChip: {
    backgroundColor: `${AVAQualisTheme.colors.success}20`,
    borderColor: AVAQualisTheme.colors.success,
  },
  
  localChip: {
    backgroundColor: `${AVAQualisTheme.colors.warning}20`,
    borderColor: AVAQualisTheme.colors.warning,
  },
  
  // NOVO ESTILO - Chip com status alterado
  syncStatusChangedChip: {
    backgroundColor: '#FFC107', // Chip amarelo para alertar sobre mudança
  },
  
  // NOVO ESTILO - Texto para status alterado
  syncStatusChangedText: {
    fontSize: 10,
    color: '#D32F2F',
    marginTop: 4,
    fontStyle: 'italic',
  },
  
  chipText: {
    fontSize: 11,
    fontWeight: '600',
  },
  
  formCardDescription: {
    fontSize: 14,
    color: AVAQualisTheme.colors.secondary,
    lineHeight: 20,
    marginBottom: AVAQualisTheme.spacing.sm,
  },

  // NOVOS ESTILOS - Estatísticas do formulário melhorado
  formCardStats: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: AVAQualisTheme.spacing.sm,
    marginBottom: AVAQualisTheme.spacing.sm,
  },
  
  formStat: {
    fontSize: 12,
    color: AVAQualisTheme.colors.tertiary,
    fontWeight: '600',
    backgroundColor: `${AVAQualisTheme.colors.surfaceVariant}50`,
    paddingHorizontal: AVAQualisTheme.spacing.sm,
    paddingVertical: 4,
    borderRadius: AVAQualisTheme.borderRadius.sm,
  },
  
  formEssentialStat: {
    backgroundColor: `${AVAQualisTheme.colors.warning}15`,
    color: AVAQualisTheme.colors.warning,
    fontWeight: 'bold',
  },
  
  formComplexityStat: {
    fontWeight: 'bold',
  },
  
  formCardActions: {
    flexDirection: 'row',
    justifyContent: 'flex-end',
    gap: AVAQualisTheme.spacing.xs,
    flexWrap: 'wrap',
  },
  
  editButton: {
    borderColor: AVAQualisTheme.colors.primary,
    minWidth: 80,
  },
  
  uploadButton: {
    minWidth: 80,
  },
  
  deleteButton: {
    borderColor: AVAQualisTheme.colors.error,
    minWidth: 80,
  },

  // Estado Vazio
  emptyCard: {
    backgroundColor: AVAQualisTheme.colors.surfaceVariant,
    borderStyle: 'dashed',
    borderWidth: 2,
    borderColor: AVAQualisTheme.colors.outline,
    borderRadius: AVAQualisTheme.borderRadius.lg,
    marginTop: AVAQualisTheme.spacing.lg,
  },
  
  emptyContent: {
    alignItems: 'center',
    paddingVertical: AVAQualisTheme.spacing.xl,
  },
  
  emptyIcon: {
    fontSize: 64,
    marginBottom: AVAQualisTheme.spacing.md,
  },
  
  emptyTitle: {
    textAlign: 'center',
    marginBottom: AVAQualisTheme.spacing.sm,
    color: AVAQualisTheme.colors.primary,
    fontSize: 18,
  },
  
  emptyText: {
    textAlign: 'center',
    color: AVAQualisTheme.colors.secondary,
    lineHeight: 22,
    fontSize: 14,
    maxWidth: '85%',
    fontWeight: '500',
  },
  
  emptyActions: {
    justifyContent: 'center',
    paddingHorizontal: AVAQualisTheme.spacing.md,
  },

  // Modal de Seleção de Avaliadores
  avaliadorModalContainer: {
    backgroundColor: AVAQualisTheme.colors.surface,
    borderRadius: AVAQualisTheme.borderRadius.lg,
    marginHorizontal: 20,
    marginVertical: 60,
    maxHeight: '80%',
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 8 },
    shadowOpacity: 0.25,
    shadowRadius: 12,
    elevation: 20,
  },

  avaliadorModalHeader: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingHorizontal: 24,
    paddingTop: 24,
    paddingBottom: 16,
    borderBottomWidth: 1,
    borderBottomColor: AVAQualisTheme.colors.outline,
  },

  avaliadorModalTitle: {
    fontSize: 18,
    fontWeight: 'bold',
    color: AVAQualisTheme.colors.primary,
    flex: 1,
  },

  closeModalButton: {
    backgroundColor: AVAQualisTheme.colors.errorContainer,
    borderRadius: 16,
    width: 32,
    height: 32,
    justifyContent: 'center',
    alignItems: 'center',
  },

  closeModalText: {
    fontSize: 16,
    color: AVAQualisTheme.colors.error,
    fontWeight: 'bold',
  },

  avaliadorModalContent: {
    maxHeight: 400,
    paddingHorizontal: 24,
  },

  avaliadorModalSubtitle: {
    fontSize: 14,
    color: AVAQualisTheme.colors.secondary,
    marginBottom: AVAQualisTheme.spacing.md,
    fontWeight: '500',
    paddingVertical: AVAQualisTheme.spacing.sm,
  },

  avaliadorModalItem: {
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: AVAQualisTheme.colors.background,
    padding: AVAQualisTheme.spacing.md,
    marginBottom: AVAQualisTheme.spacing.sm,
    borderRadius: AVAQualisTheme.borderRadius.md,
    borderWidth: 1,
    borderColor: AVAQualisTheme.colors.outline,
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 1 },
    shadowOpacity: 0.1,
    shadowRadius: 2,
    elevation: 1,
  },

  avaliadorModalItemContent: {
    flex: 1,
  },

  avaliadorModalItemName: {
    fontSize: 16,
    fontWeight: '600',
    color: AVAQualisTheme.colors.onSurface,
    marginBottom: AVAQualisTheme.spacing.xs,
  },

  avaliadorModalItemLogin: {
    fontSize: 13,
    color: AVAQualisTheme.colors.secondary,
    fontStyle: 'italic',
  },

  avaliadorModalItemArrow: {
    fontSize: 18,
    color: AVAQualisTheme.colors.primary,
    fontWeight: 'bold',
    marginLeft: AVAQualisTheme.spacing.sm,
  },

  noAvaliadorContainer: {
    alignItems: 'center',
    paddingVertical: AVAQualisTheme.spacing.xl,
    backgroundColor: `${AVAQualisTheme.colors.warning}10`,
    borderRadius: AVAQualisTheme.borderRadius.md,
    borderWidth: 1,
    borderColor: AVAQualisTheme.colors.warning,
    marginVertical: AVAQualisTheme.spacing.md,
  },

  noAvaliadorText: {
    fontSize: 16,
    fontWeight: '600',
    color: AVAQualisTheme.colors.warning,
    marginBottom: AVAQualisTheme.spacing.xs,
  },

  noAvaliadorSubtext: {
    fontSize: 13,
    color: AVAQualisTheme.colors.secondary,
    textAlign: 'center',
    fontStyle: 'italic',
  },

  avaliadorModalFooter: {
    paddingHorizontal: 24,
    paddingVertical: 16,
    borderTopWidth: 1,
    borderTopColor: AVAQualisTheme.colors.outline,
    alignItems: 'center',
  },

  cancelAvaliadorButton: {
    backgroundColor: 'transparent',
    borderWidth: 1,
    borderColor: AVAQualisTheme.colors.outline,
    borderRadius: AVAQualisTheme.borderRadius.md,
    paddingHorizontal: 32,
    paddingVertical: 12,
    minWidth: 120,
    alignItems: 'center',
  },

  cancelAvaliadorText: {
    fontSize: 14,
    fontWeight: '600',
    color: AVAQualisTheme.colors.primary,
  },

  // Componentes Auxiliares
  divider: {
    marginVertical: AVAQualisTheme.spacing.sm,
    backgroundColor: AVAQualisTheme.colors.outline,
  },
  
  bottomSpacer: {
    height: AVAQualisTheme.spacing.xl,
  },

  // Loading Overlay
  loadingOverlay: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0,0,0,0.75)',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 100000, // MUITO ALTO para overlay de loading
  },
  
  loadingContent: {
    backgroundColor: AVAQualisTheme.colors.surface,
    padding: AVAQualisTheme.spacing.xl,
    borderRadius: AVAQualisTheme.borderRadius.lg,
    alignItems: 'center',
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 8 },
    shadowOpacity: 0.25,
    shadowRadius: 12,
    elevation: 8,
    minWidth: 250,
    maxWidth: '80%',
  },
  
  loadingText: {
    color: AVAQualisTheme.colors.primary,
    marginTop: AVAQualisTheme.spacing.md,
    fontSize: 16,
    fontWeight: 'bold',
    textAlign: 'center',
  },
  
  loadingSubtext: {
    color: AVAQualisTheme.colors.secondary,
    marginTop: AVAQualisTheme.spacing.xs,
    fontSize: 13,
    fontWeight: '500',
    textAlign: 'center',
  },

  // Dialog Personalizado
  modalOverlay: {
    flex: 1,
    backgroundColor: 'rgba(0, 0, 0, 0.6)',
    justifyContent: 'center',
    alignItems: 'center',
    padding: 20,
    zIndex: 500000, // MUITO ALTO para modal
  },
  
  dialogContainer: {
    backgroundColor: AVAQualisTheme.colors.surface,
    borderRadius: AVAQualisTheme.borderRadius.lg,
    minWidth: 320,
    maxWidth: '90%',
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 8 },
    shadowOpacity: 0.25,
    shadowRadius: 12,
    elevation: 20, // ALTO para dialog
  },
  
  dialogHeader: {
    paddingHorizontal: 24,
    paddingTop: 24,
    paddingBottom: 16,
    borderBottomWidth: 1,
    borderBottomColor: AVAQualisTheme.colors.outline,
  },
  
  dialogTitle: {
    fontSize: 18,
    fontWeight: 'bold',
    color: AVAQualisTheme.colors.primary,
  },
  
  dialogContent: {
    paddingHorizontal: 24,
    paddingVertical: 20,
  },
  
  dialogMessage: {
    fontSize: 15,
    lineHeight: 22,
    color: AVAQualisTheme.colors.onSurface,
  },
  
  dialogActions: {
    flexDirection: 'row',
    justifyContent: 'flex-end',
    paddingHorizontal: 16,
    paddingVertical: 16,
    gap: 12,
    borderTopWidth: 1,
    borderTopColor: AVAQualisTheme.colors.outline,
  },
  
  dialogButton: {
    paddingHorizontal: 20,
    paddingVertical: 12,
    borderRadius: AVAQualisTheme.borderRadius.md,
    minWidth: 90,
    alignItems: 'center',
    justifyContent: 'center',
  },
  
  dialogButtonSecondary: {
    backgroundColor: 'transparent',
    borderWidth: 1,
    borderColor: AVAQualisTheme.colors.outline,
  },
  
  dialogButtonPrimary: {
    backgroundColor: AVAQualisTheme.colors.primary,
  },
  
  dialogButtonText: {
    fontSize: 14,
    fontWeight: '600',
  },
  
  dialogButtonTextSecondary: {
    color: AVAQualisTheme.colors.primary,
  },
  
  dialogButtonTextPrimary: {
    color: AVAQualisTheme.colors.onPrimary,
  },

  quickSelectionScrollView: {
    maxHeight: 150, // Altura máxima para o scroll
    marginBottom: AVAQualisTheme.spacing.sm,
  },
  
  // NOVOS ESTILOS para a sincronização com o servidor
  syncStatusContainer: {
    backgroundColor: '#E3F2FD',
    borderRadius: AVAQualisTheme.borderRadius.md,
    padding: AVAQualisTheme.spacing.md,
    marginBottom: AVAQualisTheme.spacing.md,
    borderWidth: 1,
    borderColor: '#BBDEFB',
  },
  
  syncStatusHeader: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: AVAQualisTheme.spacing.sm,
  },
  
  syncStatusTitle: {
    fontSize: 16,
    fontWeight: 'bold',
    color: '#1976D2',
  },
  
  syncButton: {
    backgroundColor: AVAQualisTheme.colors.primary,
    borderRadius: AVAQualisTheme.borderRadius.md,
    paddingVertical: 6,
    paddingHorizontal: 12,
  },
  
  syncButtonText: {
    color: 'white',
    fontSize: 12,
    fontWeight: 'bold',
  },
  
  lastSyncText: {
    fontSize: 12,
    color: '#1565C0',
    marginBottom: 4,
  },
  
  syncErrorText: {
    fontSize: 12,
    color: AVAQualisTheme.colors.error,
    marginBottom: 8,
    fontWeight: '500',
  },
  
  serverStatusInfo: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginTop: 4,
  },
  
  serverStatusText: {
    fontSize: 12,
    color: '#0D47A1',
    fontWeight: '500',
  },
  
  // NOVO ESTILO - Card de sincronização em andamento
  syncingCard: {
    marginBottom: 12,
    padding: 4,
    backgroundColor: '#E3F2FD',
    borderLeftWidth: 4,
    borderLeftColor: AVAQualisTheme.colors.primary,
  },
  
  syncingContent: {
    flexDirection: 'row',
    alignItems: 'center',
    padding: 8,
  },
  
  syncingText: {
    fontSize: 14,
    color: AVAQualisTheme.colors.primary,
    marginLeft: 8,
  },
  
  // NOVOS ESTILOS - Legenda para ícones
  legendContainer: {
    backgroundColor: '#F5F5F5',
    borderRadius: AVAQualisTheme.borderRadius.md,
    padding: AVAQualisTheme.spacing.md,
    marginTop: AVAQualisTheme.spacing.sm,
  },
  
  legendTitle: {
    fontSize: 14,
    fontWeight: 'bold',
    color: '#424242',
    marginBottom: 8,
  },
  
  legendItem: {
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 4,
  },
  
  legendText: {
    fontSize: 12,
    color: '#757575',
    marginLeft: 8,
  },

  quickSelectionButtonSpecial: {
  backgroundColor: '#FFF3E0', // Fundo amarelo claro
  borderColor: '#FF9800', // Borda laranja
  borderWidth: 2,
},
quickSelectionButtonTextSpecial: {
  color: '#E65100', // Texto laranja escuro
  fontWeight: 'bold',
},

// Estilos para emails das lideranças
emailsContainer: {
  marginTop: 16,
  marginBottom: 8,
},
emailInputContainer: {
  flexDirection: 'row',
  alignItems: 'flex-start',
  gap: 8,
},
emailInput: {
  flex: 1,
  backgroundColor: '#fff',
},
addEmailButton: {
  backgroundColor: AVAQualisTheme.colors.primary,
  paddingHorizontal: 16,
  paddingVertical: 12,
  borderRadius: 8,
  justifyContent: 'center',
  alignItems: 'center',
  marginTop: 5,
},
addEmailButtonDisabled: {
  backgroundColor: '#ccc',
  opacity: 0.7,
},
addEmailButtonText: {
  color: '#fff',
  fontSize: 14,
  fontWeight: 'bold',
},
emailErrorText: {
  color: AVAQualisTheme.colors.error,
  fontSize: 12,
  marginTop: 4,
  marginLeft: 4,
},
emailsList: {
  marginTop: 12,
  backgroundColor: '#f5f5f5',
  padding: 12,
  borderRadius: 8,
},
emailsListTitle: {
  fontSize: 14,
  fontWeight: 'bold',
  color: '#333',
  marginBottom: 8,
},
emailItem: {
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'center',
  paddingVertical: 6,
  paddingHorizontal: 8,
  backgroundColor: '#fff',
  marginBottom: 4,
  borderRadius: 4,
  borderLeftWidth: 3,
  borderLeftColor: AVAQualisTheme.colors.primary,
},
emailItemText: {
  flex: 1,
  fontSize: 13,
  color: '#555',
},
removeEmailButton: {
  padding: 4,
  marginLeft: 8,
},
removeEmailButtonText: {
  color: AVAQualisTheme.colors.error,
  fontSize: 18,
  fontWeight: 'bold',
},
emailsHelpText: {
  fontSize: 12,
  color: '#666',
  fontStyle: 'italic',
  marginTop: 8,
},

// Estilos para Processo Avaliado
processoContainer: {
  marginBottom: AVAQualisTheme.spacing.xl,
  zIndex: 200000,
},
processoDropdownContainer: {
  position: 'relative',
  zIndex: 200000,
},
processoInput: {
  backgroundColor: '#fff',
  marginBottom: 8,
  zIndex: 200000,
},
processoDropdownList: {
  position: 'absolute',
  top: '100%',
  left: 0,
  right: 0,
  backgroundColor: AVAQualisTheme.colors.surface,
  borderRadius: AVAQualisTheme.borderRadius.md,
  borderWidth: 2,
  borderColor: AVAQualisTheme.colors.primary,
  maxHeight: 250,
  zIndex: 999999,
  elevation: 100,
  shadowColor: '#000',
  shadowOffset: { width: 0, height: 12 },
  shadowOpacity: 0.6,
  shadowRadius: 16,
},
processoDropdownItem: {
  padding: AVAQualisTheme.spacing.md,
  borderBottomWidth: 1,
  borderBottomColor: AVAQualisTheme.colors.outline + '30',
  backgroundColor: AVAQualisTheme.colors.surface,
},
processoDropdownItemHovered: {
  backgroundColor: `${AVAQualisTheme.colors.primary}10`,
},
processoDropdownHeader: {
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'center',
  marginBottom: 4,
},
processoDropdownText: {
  fontSize: 14,
  color: AVAQualisTheme.colors.onSurface,
  fontWeight: '600',
},
processoDropdownId: {
  fontSize: 11,
  color: '#999',
  fontStyle: 'italic',
},
noProcessoContainer: {
  backgroundColor: '#FFF8E1',
  padding: 16,
  borderRadius: 8,
  borderWidth: 1,
  borderColor: '#FFD54F',
  marginBottom: 8,
},
noProcessoText: {
  fontSize: 13,
  color: '#F57C00',
  textAlign: 'center',
  marginBottom: 4,
},
noProcessoSubtext: {
  fontSize: 12,
  color: '#666',
  textAlign: 'center',
  fontStyle: 'italic',
},

// NOVOS ESTILOS - Layout melhorado para processos selecionados
processosSelectedContainer: {
  marginTop: 12,
},
processosSelectedHeader: {
  flexDirection: 'row',
  alignItems: 'center',
  marginBottom: 8,
},
processosSelectedTitle: {
  fontSize: 13,
  fontWeight: 'bold',
  color: AVAQualisTheme.colors.info,
  flex: 1,
},
processosSelectedCount: {
  backgroundColor: AVAQualisTheme.colors.info,
  paddingHorizontal: 8,
  paddingVertical: 2,
  borderRadius: 10,
},
processosSelectedCountText: {
  fontSize: 11,
  color: '#fff',
  fontWeight: 'bold',
},
processosScrollContainer: {
  maxHeight: 200,
  backgroundColor: '#f8f9fa',
  borderRadius: 8,
  padding: 8,
},
processoSelectedCard: {
  backgroundColor: '#fff',
  borderRadius: 8,
  padding: 12,
  marginBottom: 8,
  borderLeftWidth: 3,
  borderLeftColor: AVAQualisTheme.colors.info,
  shadowColor: '#000',
  shadowOffset: { width: 0, height: 1 },
  shadowOpacity: 0.1,
  shadowRadius: 2,
  elevation: 2,
},
processoSelectedHeader: {
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'space-between',
  marginBottom: 4,
},
processoSelectedInfo: {
  flex: 1,
  marginRight: 8,
},
processoSelectedNome: {
  fontSize: 14,
  fontWeight: '600',
  color: '#333',
  marginBottom: 2,
},
processoSelectedId: {
  fontSize: 11,
  color: '#666',
  fontStyle: 'italic',
},
processoSelectedActions: {
  flexDirection: 'row',
  alignItems: 'center',
  gap: 8,
},
processoEditButton: {
  backgroundColor: '#FFF3E0',
  paddingHorizontal: 10,
  paddingVertical: 6,
  borderRadius: 6,
},
processoEditButtonText: {
  fontSize: 11,
  color: '#E65100',
  fontWeight: '600',
},
processoRemoveButton: {
  backgroundColor: AVAQualisTheme.colors.errorContainer,
  borderRadius: 14,
  width: 28,
  height: 28,
  justifyContent: 'center',
  alignItems: 'center',
},
processoRemoveButtonText: {
  fontSize: 16,
  color: AVAQualisTheme.colors.error,
  fontWeight: 'bold',
},
processoEditContainer: {
  marginTop: 8,
  paddingTop: 8,
  borderTopWidth: 1,
  borderTopColor: '#e0e0e0',
},
processoEditInput: {
  backgroundColor: '#f5f5f5',
  borderRadius: 6,
  paddingHorizontal: 10,
  marginBottom: 8,
  fontSize: 14,
  minHeight: 40,
},
processoEditActions: {
  flexDirection: 'row',
  justifyContent: 'flex-end',
  gap: 8,
},
processoEditWarning: {
  backgroundColor: '#FFEBEE',
  padding: 8,
  borderRadius: 6,
  marginBottom: 8,
},
processoEditWarningText: {
  fontSize: 11,
  color: '#C62828',
  textAlign: 'center',
  fontStyle: 'italic',
},
addProcessoButton: {
  backgroundColor: AVAQualisTheme.colors.primary,
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'center',
  padding: 12,
  borderRadius: 8,
  marginTop: 8,
},
addProcessoButtonText: {
  color: '#fff',
  fontSize: 13,
  fontWeight: '600',
  marginLeft: 6,
},
});